import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Loading/Loading";

import styles from "./Checkbox.module.css";

const Checkbox = (props) => {
  const { setFilter, id } = props.column;
  const [value, setValue] = useState(props.value);
  const [isLoading, setIsLoading] = useState(false);

  let filterName = id + "_filter";
  const dispatch = useDispatch();
  const columnFilterValue = useSelector(state => state[filterName]);

  // useEffect(() => {
  //   if (columnFilterValue) {
  //     setFilter(columnFilterValue)
  //   }
  // }, []);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
      setIsLoading(false);
    }
  }, [props]);

  const updateVisibility = (elId, updatedValue) => {
    // dispatch({ type: "visible_on_bi_filter", filterValue: updatedValue});
    setIsLoading(true);
    props.performAction(elId, updatedValue, props.column);
  }
  // console.log("Checkbox value: ", value);
  return (
    <div className={styles.visibleOnBiCheckboxContainer}>
      {!isLoading && <input type="checkbox" className={styles.visibleOnBiCheckbox} disabled={props.disabled} checked={value} onChange={(e) => {
        updateVisibility(props.elementId, e.target.checked)
      }} />}
      {isLoading && <Loading  size={"20px"} />}
    </div>
  );
}

export default Checkbox;